/** True when `pathname` is exactly `navPath` or a nested segment under it (not `/donors2` for `/donors`). */
export function pathMatchesNavPath(pathname: string, navPath: string): boolean {
  if (navPath === '/') return pathname === '/'
  return pathname === navPath || pathname.startsWith(`${navPath}/`)
}
